module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-26.965d9da3.png";